import {useLocation} from 'react-router'

import BetaToggle from './Toggle'

const HomeworkBetaToggle = () => {
  const {pathname} = useLocation()

  if (!pathname.startsWith('/institute/homework')) {
    return null
  }

  return <BetaToggle moduleKey='homework-beta' color='primary' title='Homework' />
}

export default HomeworkBetaToggle
